import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { SelectCustom } from '../../../../common/selectCustom'
import { SCROLL_LAYOUT_ELEMENT_ID } from '../../../../layout/LayoutContainer'
import { SIDE_BAR_SCROLL_ID } from '../../../SideBarUserManagement'
import { ALL_STATUS } from '../constants'
import {
  changeFilter,
  selectFilterByKey,
  selectOrderStatus,
} from '../store/slice'

export const OrderStatus = () => {
  const dispatch = useDispatch()

  const orderStatus = useSelector(selectOrderStatus)
  const orderStatusActive = useSelector(selectFilterByKey('orderStatusActive'))

  const chooseItem = (data) => {
    dispatch(changeFilter({ orderStatusActive: data }))
  }

  const orderStatusSelection = [
    ALL_STATUS,
    ...orderStatus.map((item) => ({
      label: `userManagement.orderManagement.${item?.status.toUpperCase()}`,
      value: item.status,
      isI18n: true,
    })),
  ]

  return (
    <div className="dFlex alignItemsCenter">
      <Translate
        value="userManagement.orderManagement.ORDER_STATUS"
        className="fw600"
      />
      <SelectCustom
        className="mx1"
        activeItem={orderStatusActive}
        data={orderStatusSelection}
        chooseItem={chooseItem}
        isI18n
        isNoWrap
        scrollId={[SIDE_BAR_SCROLL_ID, SCROLL_LAYOUT_ELEMENT_ID]}
      />
    </div>
  )
}
